export enum UserType {
  Anonymous = 0,
  Internal = 1,
  Jobseeker = 2,
  CustomerAgent = 3,
}
